import { render, staticRenderFns } from "./JobConfig.vue?vue&type=template&id=40db9f0a&"
import script from "./JobConfig.vue?vue&type=script&lang=js&"
export * from "./JobConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports